import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "../config/site";

interface SeoOptions {
    title: string;
    description: string;
    // false para páginas que no deben aparecer en buscadores (404)
    index?: boolean;
}

// Crea o actualiza una etiqueta <meta> o <link> del <head>
const setTag = (selector: string, create: () => HTMLElement, attr: string, value: string) => {
    let el = document.head.querySelector<HTMLElement>(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
};

const setMeta = (key: "name" | "property", name: string, content: string) =>
    setTag(`meta[${key}="${name}"]`, () => {
        const meta = document.createElement("meta");
        meta.setAttribute(key, name);
        return meta;
    }, "content", content);

// Título, descripción, URL canónica y etiquetas para redes de la página actual.
// Los valores por defecto (para quien no ejecuta JavaScript) están en public/index.html.
export const useSeo = ({ title, description, index = true }: SeoOptions) => {
    const { pathname } = useLocation();

    useEffect(() => {
        const url = SITE.url + pathname;
        document.title = title;
        setMeta("name", "description", description);
        setMeta("name", "robots", index ? "index, follow, max-image-preview:large" : "noindex, follow");
        setTag('link[rel="canonical"]', () => {
            const link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            return link;
        }, "href", url);
        setMeta("property", "og:url", url);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
    }, [title, description, index, pathname]);
};
